define([
	"dojo/_base/declare",
	"csi/heading/Property",
	"csi/html",
	"csi/session",
	"csi/store/UserNames"
], function(declare,Property,html,session,UserNames) {

	// This renderer only used for references to User by Created By and Published By properties

	return declare(Property, {
		canLink: function() {
			// summary: ref attributes are already links
			return false;
		},

		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: render value for attribute in HTML
			var value = this._getValue(ctx, h);
			var name = UserNames.get(value);
			if (name) {
				var anchor;

				if (ctx.canLink()) {
					// cannot use createBrowseAnchor because we may not always have user node since dependency paths don't work for node properties
					const target = ctx.fd?.linkTarget ?? "_self";

					anchor = html.create("a", {
						"class": html.CSS_BROWSE,
						href: session.getLocationForUrl(value),
						target,
					}, refNode);
				}

				html.text(anchor || refNode, name);
				return true;
			}

			return false;
		},

		toValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return user name - does not support display format
			return UserNames.get(this._getValue(ctx, h)) || "";
		},

		_toFilterValue: function(/*Context*/ctx, /*Heading*/h, /*Any*/value) {
			// summary: filter by name of referenced user
			return UserNames.get(value);
		}
	});
});